
<div style="width:100%">
  <mat-form-field appearance="outline" style="width:100%">
    <button matPrefix mat-icon-button (click)="decreaseQty()">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <input matInput type="text" style="text-align: center;" [value]="value" (input)="userInput($event)">

    <button matSuffix mat-icon-button (click)="increaseQty()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </mat-form-field>
</div>

<div *ngIf=" max !== null && value === max">You have reached your limit</div> 
